import React, { useState } from "react";
import Form from "./Form";
import { Redirect } from "react-router-dom";
import { SignUpData } from "../../firebase/users";
import { createUserAccountAndProfile } from "../../firebase/users";
import Spinner from "../shared/Spinner";
import { Grid } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import LogoYfca from "./svg/logo-yfca.svg";
import LogoActadapt from "./svg/logo-actadapt.png";
import LogoGca from "./svg/logo-gca.svg";
import DefaultBackground from "./svg/register-background.svg";

const useStyles = makeStyles((theme) => ({
  formContainer: {
    // height: "80%",

  },
  signup: {
    marginTop: "50px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "0px",
    }
  },
  title: {
    fontSize: "32px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "2.66",
    letterSpacing: "-0.06px",
    color: colors.TEXT_PRIMARY,
  },
  url: {
    color: colors.URL,
    fontWeight: 500,
  },
  sideImage: {
    backgroundImage: `url(${DefaultBackground})`,
    position: "absolute",
    height: "100%",
    width: "250px",
    left: 0,
  },
  input: {
    width: "450px"
  },
  imgContainer: {
    position: "relative",
    width: "calc(100% - 275px)",
    bottom: "0px",
    top: "100px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "50px",
      bottom: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginLeft: "0",
      top: "20px",
      marginTop: "100px",
      position: "relative",
    },
  },
  gridImage: {
    margin: "0 auto",
  }
}));

type StatusType = "form" | "loading" | "success" | "error";

export default function SignUpPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [status, setStatus] = useState<StatusType>("form");

  if (status === "success") {
    // Firefox can only read "strings"
    sessionStorage.setItem("justSignedUp", "true");
    return <Redirect to={{ pathname: "/" }} />
  }

  async function save(user: SignUpData) {
    setStatus("loading");

    try {
      await createUserAccountAndProfile(user);
      setStatus("success");
    } catch (error) {
      setStatus("error");
    }
  }

  return (
    <>
      <Grid className={classes.formContainer} container item xs={12} md={12} spacing={2}>
        <Hidden smDown>
          <Grid item xs={2} sm={2} md={4}>
            <Grid container item className={classes.sideImage}/>
          </Grid>
        </Hidden>
        <Hidden smUp>
          <Grid item xs={2} sm={2} md={4}>
          </Grid>
        </Hidden>
        <Grid item xs={8} sm={12} md={8} container className={classes.signup}>
          {status === "form" && (
            <>
              <div className={classes.title}>{t("signup.signup")}</div>
              <Form save={save} />
            </>
          )}

          <Spinner isVisible={status === "loading"}></Spinner>

          {status === "error" && <>{t("signup.error_content")}</>}
        </Grid>
      </Grid>
      <Grid className={classes.imgContainer} container md={12} item xs={12} spacing={2}>
        <Grid container item xs={12} sm={4}>
          <img src={LogoYfca} style={{width: "80px"}} className={classes.gridImage} alt="logo"/>
        </Grid>
        <Grid container item xs={12} sm={4} >
          <img src={LogoGca} className={classes.gridImage} alt="logo"/>
        </Grid>
        <Grid container item xs={12} sm={4}>
          <img src={LogoActadapt} style={{width: "auto", height: "60px", marginTop: "17px"}} className={classes.gridImage} alt="logo"/>
        </Grid>
      </Grid>
    </>
  );
}

